import { jflApi } from "../../common/authApi";

// GET /v1/roles. Each role is { roleId, name, permissions[] } - note the field
// is `name`, while POST /v1/users expects it as `roleName`.
export const fetchRoles = async () => {
  try {
    const response = await jflApi.get("/v1/roles");

    return { success: true, data: response.data?.data?.roles ?? [] };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.error?.errorMessage ||
        error.response?.data?.message ||
        error.message ||
        "Could not load roles",
    };
  }
};
